import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { money, dt } from "../../lib/api";
import { useLoad, Card, Badge, H1, Table, ainput } from "../../components/admin/ui";

export default function Orders() {
  const nav = useNavigate();
  const [status, setStatus] = useState("");
  const [rows] = useLoad("/admin/orders", { status });
  return (
    <div>
      <H1 sub="Chaque commande est liée à un paiement Stripe, un ou plusieurs fournisseurs (identifiant externe), un statut et un historique d'événements.">Commandes</H1>
      <Card title={`${rows?.length ?? 0} commandes`} right={
        <select data-testid="orders-status-filter" value={status} onChange={(e) => setStatus(e.target.value)} className={ainput}>
          {["", "pending_payment", "paid", "forwarded", "shipped", "delivered", "supplier_error", "partially_refunded", "refunded", "expired"].map((s) => <option key={s} value={s}>{s || "tous"}</option>)}
        </select>}>
        <Table testid="orders-table" rows={rows || []} onRow={(o) => nav(`/admin/orders/${o.id}`)} cols={[
          ["N°", (o) => <span className="font-mono">{o.number}</span>], ["Date", (o) => <span className="text-xs">{dt(o.created_at)}</span>], ["Client", (o) => o.email],
          ["Pays", (o) => o.market], ["Statut", (o) => <Badge v={o.status} testid={`order-status-${o.number}`} />], ["Total", (o) => <span className="font-mono">{money(o.total, o.currency)}</span>],
          ["Contrib. est.", (o) => <span className="font-mono text-emerald-400">{money(o.est_contribution_eur)}</span>], ["Remboursé", (o) => <span className="font-mono">{o.refunded_amount ? money(o.refunded_amount, o.currency) : "—"}</span>],
        ]} />
      </Card>
    </div>
  );
}
